import script from "./CRommeHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CRommeHeader.vue?vue&type=script&setup=true&lang=ts"

import "./CRommeHeader.vue?vue&type=style&index=0&id=6aed5568&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aed5568"]])

export default __exports__